import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import map from 'lodash/map';
import { getDataPromise, postDataPromise } from 'brock-fetch-utils';
import {
    initializeSearchConfiguration,
    validateSearchConfiguration,
} from './initializationUtils';
import { mapSelectOptions } from '../shared/utilities/selectOptionsUtils';

export default function InitialState(props) {
    const params = useParams();

    const [initialStateError, setInitialStateError] = useState(null);
    const [initialStateLoaded, setInitialStateLoaded] = useState(false);
    const [searchConfiguration, setSearchConfiguration] = useState({});
    const [systemManifest, setSystemManifest] = useState([]);
    const [selectOptions, setSelectOptions] = useState([]);

    /* eslint-disable complexity */
    useEffect(() => {
        async function getSystemManifest() {
            return getDataPromise(props.uriConstants.getSystemManifestUri).then(
                (response) => response,
                () => setInitialStateError('Failed to load system manifest')
            );
        }

        async function getSelectOptions(filterConfigurations) {
            const apiKeys = map(
                filterConfigurations,
                (filter) => filter.apiKey
            ).filter((x) => x);

            return postDataPromise(
                props.uriConstants.selectOptionsUri,
                apiKeys
            ).then(
                (response) => mapSelectOptions(response),
                () => setInitialStateError('Failed to load select options')
            );
        }

        async function getSearchConfiguration() {
            return getDataPromise(
                props.uriConstants.getSearchConfigurationUri(params.searchKey)
            ).then(initializeSearchConfiguration, () =>
                setInitialStateError(
                    `Failed to load search configuration for key: ${params.searchKey}`
                )
            );
        }

        async function initialize() {
            const configuration = await getSearchConfiguration();

            const systemManifestResponse = props.uriConstants
                .getSystemManifestUri
                ? await getSystemManifest()
                : [];

            const selectOptionsResponse = await getSelectOptions(
                configuration.filterConfigurations
            );

            validateSearchConfiguration(configuration);

            setSearchConfiguration(configuration);
            setSystemManifest(systemManifestResponse);
            setSelectOptions(selectOptionsResponse);
            setInitialStateLoaded(true);
        }

        initialize();
    }, [params.searchKey, props.uriConstants]);

    if (initialStateError) {
        throw Error(initialStateError);
    }

    return props.render({
        initialConfiguration: searchConfiguration,
        initialStateLoaded,
        selectOptions,
        systemManifest,
    });
}

InitialState.propTypes = {
    render: PropTypes.func.isRequired,
    uriConstants: PropTypes.instanceOf(Object).isRequired,
};
